import { render, staticRenderFns } from "./tryPlay.vue?vue&type=template&id=2c86eb74&scoped=true"
import script from "./tryPlay.vue?vue&type=script&lang=js"
export * from "./tryPlay.vue?vue&type=script&lang=js"
import style0 from "./tryPlay.vue?vue&type=style&index=0&id=2c86eb74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c86eb74",
  null
  
)

export default component.exports